// TODO: #1175
export function ArticleModuleVideo360() {
	return <div>ArticleModuleVideo360</div>;
}
